import { useIntl } from 'react-intl';

export const NoDataView = () => {
    const intl = useIntl();
    return (
        <div data-testid='no-data-view' className='display-flex justify-content-center max-width-100pct'>
            <div className='margin-0 width-100pct max-width-600 panel-default panel padding-15 border-none'>
                <div className='display-flex flex-column align-items-center text-center padding-25'>
                    <div className='text-size-h2 margin-bottom-20'>
                        <span className='uikit-icon icon-looking-glass-man text-color-light text-size-300pct' />
                    </div>
                    <div className='text-size-h3 text-size-h2-xl line-height-125rel text-color-dark text-medium width-500 max-width-100pct text-wrap-balance'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.common.no-data-view.title',
                            defaultMessage: 'Nothing found',
                        })}
                    </div>
                    <div className='text-color-dark margin-top-15 width-500 max-width-100pct text-wrap-balance'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.common.no-data-view.label',
                            defaultMessage: 'Try changing your filters or search terms',
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
